import axios from 'axios';
import { GOOGLE_DYNAMIC_LINK_DOMAIN_URL_PREFIX } from '../define/global';

const UPLOADER_SERVER_URL =
  process.env.REACT_APP_DOC_UPLOADER_SERVER || 'https://woxpo-s3-uploader-staging.herokuapp.com';

const innerApi = axios.create({
  baseURL: UPLOADER_SERVER_URL
});

export const pushFileByServer = async (fileName, docFile) => {
  const bodyFormData = new FormData();
  bodyFormData.append('doc', new File([docFile.blob], fileName));

  const res = await innerApi({
    url: '/upload',
    data: bodyFormData,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  const { key, su } = res.data;

  return { key, su };
};

export const getS3MetaData = async (key) => {
  try {
    const res = await innerApi({
      url: `/getMetaData/${key}`,
      method: 'GET'
    });

    return res.data;
  } catch (error) {
    throw new Error('getS3MetaDataFail by ' + error.message);
  }
};

export const generateShortLink = async (shareURL) => {
  try {
    const res = await innerApi({
      method: 'POST',
      url: '/generateShortLink',
      data: shareURL,
      headers: { 'Content-Type': 'text/plain' }
    });

    return res.data;
  } catch (error) {
    throw new Error('generateShortLink fail By ' + error.message);
  }
};

const GOOGLE_DYNAMIC_URL_REST_API = 'https://firebasedynamiclinks.googleapis.com/v1/shortLinks';
const GOOGLE_DYNAMIC_LINK_API_KEY = process.env.REACT_APP_GOOGLE_DYNAMIC_LINK_API_KEY;
export const generateShortLinkByDirect = async (shareURL) => {
  try {
    const res = await axios({
      url: `${GOOGLE_DYNAMIC_URL_REST_API}?key=${GOOGLE_DYNAMIC_LINK_API_KEY}`,
      method: 'POST',
      data: JSON.stringify({
        dynamicLinkInfo: {
          domainUriPrefix: GOOGLE_DYNAMIC_LINK_DOMAIN_URL_PREFIX,
          link: shareURL
        }
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return res.data.shortLink;
  } catch (error) {
    throw new Error('generateShortLinkByDirect fail By ' + error.message);
  }
};

export const getNotification = async (limit, lang) => {
  try {
    const res = await innerApi({
      method: 'GET',
      url: `/getNotice?${limit !== undefined ? 'limit=' + limit : ''}&lang=${lang}`
    });

    return res.data;
  } catch (error) {
    throw new Error('getNotice fail By ' + error.message);
  }
};
